// src/redux/store.js
import { configureStore } from '@reduxjs/toolkit';
import locksReducer from './locksSlice';
import authReducer from './authSlice';

export const store = configureStore({
  reducer: {
    locks: locksReducer,
    auth: authReducer,
  },
});
